/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-05-11 15:30:26
 * @LastEditTime: 2023-11-08 16:11:29
 * @LastEditors: hexy
 * @Description  : 月报单价确认
 * @FilePath: \ICPSxin\src\api\internetSales\monthlyReportUnitRecord.js
 */
import request from "@/utils/request";
/*查询*/
export const queryPage = "/icps/system/sign/settlement/cycleManage/queryEngineeringPage";
export const queryPageByMonth = "/icps/system/sign/settlement/cycleManage/queryPage";
export const queryPageByMonthRecord = "/icps/system/sign/settlement/concrete/queryPage";
//获取调价记录弹窗
export function queryHisttoryList(data) {
    return request({
      url: "/icps/system/sign/settlement/concrete/queryHisttoryList",
      method: "post",
      data,
    });
  }
  //生成月报
export function saveNewMouth(data) {
  return request({
    url: "/icps/system/sign/settlement/cycleManage/saveNewMouth",
    method: "post",
    data,
  });
}
//获取信息价记录弹窗
export function queryHisttoryPeriodList(data) {
    return request({
      url: "/icps/system/sign/settlement/concrete/queryHisttoryPeriodList",
      method: "post",
      data,
    });
  }
//获取最近周期记录
export function queryRecentlyResord(data) {
    return request({
      url: "/icps/system/sign/settlement/cycleManage/queryRecentlyResord",
      method: "post",
      data,
    });
  }
//生成最近周期记录
export function saveCycleManage(data) {
    return request({
      url: "/icps/system/sign/settlement/cycleManage/saveCycleManage",
      method: "post",
      data,
    });
  }
//删除最近周期记录
export function deleteCycleManage(params) {
    return request({
      url: "/icps/system/sign/settlement/cycleManage/deleteCycleManage",
      method: "get",
      params,
    });
  }

// 获取销售员
export function querySales(params) {
  return request({
    url: "/icps/system/sign/settlement/cycleManage/querySales",
    method: "get",
    params,
  });
}
// 月报单价确认-生成列表-更新
export function updatePriceManage(params) {
  return request({
    url: "/icps/system/sign/settlement/concrete/updatePriceManage",
    method: "get",
    params,
  });
}
//获取未维护的价格详情
export function queryPriceDetail(params) {
  return request({
    url: "/icps/system/sign/settlement/settlementPrice/queryPriceDetail",
    method: "get",
    params,
  });
}
//保存未维护价格
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/settlement/settlementPrice/saveOrUpdate",
    method: "post",
    data,
  });
}
//获取信息价期数
export function queryPeridList(data) {
  return request({
    url: "/icps/system/sign/settlement/concrete/queryPeridList",
    method: "post",
    data,
  });
}
//更新信息价期数
export function updateInformationPerid(params) {
  return request({
    url: "/icps/system/sign/settlement/concrete/updateInformationPerid",
    method: "get",
    params,
  });
}
//获取价格详情
export function queryPriceDetail2(params) {
  return request({
    url: "/icps/system/sign/settlement/settlementPrice/queryPriceDetail",
    method: "get",
    params,
  });
}
//更新期数
export function updatePriceDetail(params) {
  return request({
    url: "/icps/system/sign/settlement/settlementPrice/updatePriceDetail",
    method: "get",
    params,
  });
}
/**根据工程id获取税率特殊条款*/
export function getEngPriceAdjust(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getEngPriceAdjust',
    method: 'get',
    params: data
  })
}
/**判断之前是否已有信息价*/
export function queryWaitUpdateInformationPrice(data) {
  return request({
    url: '/icps/system/sign/settlement/settlementPrice/queryWaitUpdateInformationPrice',
    method: 'get',
    params: data
  })
}
/**查询当前工程供应状态*/
export function queryPhaseNow(data) {
  return request({
    url: '/icps/system/sign/cloudSell/control/queryPhaseNow',
    method: 'get',
    params: data
  })
}
/**确认工程供应状态*/
export function sureSupplyStatus(data) {
  return request({
    url: '/icps/system/sign/settlement/cycleManage/sureSupplyStatus ',
    method: 'post',
    data
  })
}